import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useFormik } from "formik";
import * as Yup from "yup";

import logoPayps from "media/images/common/Logo_Payps_blanc.png";
import breakingNewsImage from "media/images/contact/breaking-news.png";
import logoSalon from "media/images/contact/NRF-2025-Logo.png";

import LegalsFooter from 'components/graphics/LegalsFooter';

import {showMessage} from 'features/message/messageSlice';
import {registerContact} from 'features/contactRegistration/contactRegistrationSlice';

import TextField from '@mui/material/TextField';


export function ContactForm () {
    const dispatch = useDispatch();

    const {loading} = useSelector(state => state.contactRegistration);
    const {translatedText} = useSelector(state => state.translation);


    const submitHandler = values => {
        dispatch(registerContact(values)).then(
          result => {
            if(result.payload && result.payload.valide){
                const validMessage = {};
                validMessage.messageText=translatedText.common.confirmMessage;
                validMessage.messageType= "info";
                dispatch(showMessage(validMessage));
                resetForm(initValues);
            } 
          }
        )
        .catch(error => {
            const errorMessage = {};
            errorMessage.messageText= "Sorry an error occured ".error;
            errorMessage.messageType= "error";
            dispatch(showMessage(errorMessage));
        });
        
      };

    const initValues = {
        userFirstName: "",
        userLastName: "",
        userEmail: "",
        userPhoneNumber: "",
        userMessage: "" 
    }

    const formik = useFormik({
        initialValues: initValues,
        validationSchema: Yup.object().shape({
          userFirstName: Yup.string().required(),
          userLastName: Yup.string().required(),
          userEmail: Yup.string().email().required(),
          userPhoneNumber: Yup.string().required(),
          userMessage: Yup.string().required(),
        }),
        onSubmit: submitHandler,
      });
    
      const {
        values,
        handleChange,
        handleSubmit,
        resetForm,
        touched,
        errors,
      } = formik;

    const blurItem = loading ? " blurItem" : "";

    return(
        <div className= {`paypsScene contactFormScene ${blurItem}`}>
            <div className="contactFormContainer">
                <div className="logoPayps">
                    <img src={logoPayps} alt={translatedText.common.baseline} />
                </div>
                <div className="sceneContainer">
                    <div className="formHeader">
                        <div className='breakingNewsImage'>
                            <img src={breakingNewsImage} alt="Breaking news" />
                        </div>
                        <div className="pharmagoraImage">
                            <img src={logoSalon} alt="Vivatech" className="salonImage" />
                        </div>
                    </div>
                    <div className="formContainer">
                        <div className='pharmagoraText'>
                            {translatedText.contact.contactText}
                        </div>
                        <div className="formWhiteBlock">
                            <form onSubmit={handleSubmit}>
                                <div className='formTitle'>
                                    {translatedText.contact.formTitle}
                                </div>
                                <div className="inputFields">
                                    <TextField
                                        id="userFirstName"
                                        label={translatedText.contact.formFirstName}
                                        required={true}
                                        value={values.userFirstName }
                                        error={touched.userFirstName && typeof errors.userFirstName !== "undefined"}
                                        color="primary"
                                        onChange={handleChange}
                                        className='inputLine'
                                        variant="standard"
                                        fullWidth
                                    />
                                    <TextField
                                        id="userLastName"
                                        label={translatedText.contact.formLastName}
                                        required={true}
                                        value={values.userLastName}
                                        error={touched.userLastName && typeof errors.userLastName !== "undefined"}
                                        color="primary"
                                        onChange={handleChange}
                                        className='inputLine'
                                        variant="standard"
                                        fullWidth
                                    />
                                    <TextField
                                        id="userEmail"
                                        label={translatedText.contact.formEmail}
                                        required={true}
                                        value={values.userEmail}
                                        error={touched.userEmail && typeof errors.userEmail !== "undefined"}
                                        color="primary"
                                        onChange={handleChange}
                                        className='inputLine'
                                        variant="standard"
                                        fullWidth
                                    />
                                    <TextField
                                        id="userPhoneNumber"
                                        label={translatedText.contact.formPhoneNumber}
                                        required={true}
                                        value={values.userPhoneNumber}
                                        error={touched.userPhoneNumber && typeof errors.userPhoneNumber !== "undefined"}
                                        color="primary"
                                        onChange={handleChange}
                                        className='inputLine'
                                        variant="standard"
                                        fullWidth
                                    />
                                    <TextField
                                        id="userMessage"
                                        label={translatedText.contact.formMessage}
                                        required={true}
                                        value={values.userMessage}
                                        error={touched.userMessage && typeof errors.userMessage !== "undefined"}
                                        color="primary"
                                        onChange={handleChange}
                                        className='inputLine'
                                        variant="standard"
                                        fullWidth
                                    />
                                </div>
                                <div className="buttonLine">
                                    <input type="submit" className="submitButton" value={translatedText.contact.formButton} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                    <LegalsFooter translatedText={translatedText.footer} />
            </div>
        </div>
    )

}


export default ContactForm; 